import React, { useState } from "react";
import ChevronDown from "@mui/icons-material/KeyboardArrowDown";
import { ButtonColorScheme, ButtonType } from "types/ui";
import { Button } from "components/Buttons";

const HoverDropdownButton = ({
  disabled,
  history,
}: {
  disabled: boolean;
  history: any;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleLeaderboardClick = () => {
    history.push("/report/leaderboard");
  };

  const handleReportsClick = () => {
    history.push("/report/side-by-side");
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsHovered(true)}
    >
      <Button
        style={{ maxHeight: "40px", minWidth: "140px" }}
        title={"Reports"}
        onClick={() => {
          setIsHovered(true);
        }}
        type={ButtonType.normal}
        colorScheme={ButtonColorScheme.gradient}
      />

      {isHovered && !disabled && (
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setTimeout(() => setIsHovered(false), 200)}
          className="absolute top-full left-0 mt-1 flex space-x-2"
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "5px",
            width: "100%",
          }}
        >
          <button
            onClick={handleLeaderboardClick}
            className="
              px-4 py-2
              bg-white text-gray-800
              border border-gray-200 rounded
              hover:bg-gray-50 transition-colors
              shadow-lg
            "
          >
            Leaderboard
          </button>
          <button
            onClick={handleReportsClick}
            className="
              px-4 py-2 pl-0 pr-0
              bg-white text-gray-800
              border border-gray-200 rounded
              hover:bg-gray-50 transition-colors
              shadow-lg
            "
            style={{ marginLeft: "0px" }}
          >
            Reports
          </button>
        </div>
      )}
    </div>
  );
};

export default HoverDropdownButton;
